import React from 'react';

/**
 * The Mindris mark — a Greek mu.
 *
 * Two strokes. The left stem descends past the baseline and hooks away to the
 * lower left; the bowl sweeps right and rises into a stem that arcs over at the
 * top, drops into a short shoulder, and ends in a small curl answering the
 * descender across the diagonal.
 *
 * Mu is the Greek m, so the initial survives without drawing a Latin M — which
 * matters, because every rounded Latin M reads as golden arches. Mu has one
 * bowl and an asymmetric descender and cannot be confused with two arches.
 *
 * Drawn rather than set as a glyph so stroke weight stays even at any size and
 * doesn't shift on machines with different fonts installed.
 *
 * The component name is unchanged so existing imports keep working.
 *
 * Drop in anywhere: <BrainLogo size={32} color="white" />
 */
export default function BrainLogo({ size = 32, color = 'white' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="-40 -40 80 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g stroke={color} strokeWidth="11" strokeLinecap="round" fill="none">
        <path d="M-19 -30 C-21 -10 -22 8 -21 20 C-20 30 -25 35 -30 32" />
        <path d="M-21 4 C-21 19 -9 26 1 20 C9 15 12 5 12 -7 C12 -19 13 -26 15 -30 C17 -34 22 -34 24 -30 C26 -26 26 -18 25 -11 C24 -6 27 -3 30 -5" />
      </g>
    </svg>
  );
}
